/**
 * Service layer for beneficiaries
 *
 * Dependencies:
 *  $q      An Angular service that allows the use of deferreds
 *  $http   An Angular service to make HTTP requests. ONLY USED FOR MOCK DATA - MAY BE REMOVED ONCE WE CONNECT TO YELLOW BOX
 */
import * as _ from "lodash";
import MaskUtil from "core-ui/client/src/app/MaskUtil";
import beneficiaryTypeCodes from "../common/constants/beneficiaryTypeCodes";

var DataService = function ($http, $injector, $q, beneficiaryService) {
    var serviceData;
    var groupId = null;
    var $stateParams = $injector.get("$stateParams");
    var existingGroupId = null;

    String.prototype.toProperCase = function () {
        return this.toLowerCase().replace(/(^[a-z]| [a-z]|-[a-z])/g, function ($1) {
            return $1.toUpperCase();
        });
    };

    var normalizeRecords = function (records) {
        var normalizedRecords = [];

        angular.forEach(records, function (record) {
            normalizedRecords.push({
                code: record.code,
                description: record.description.toProperCase()
            });
        });

        return normalizedRecords;
    };

    function initServiceData() {
        serviceData = {
            showMaritalStatus: null,
            maritalStatus: null,
            beneficiaryAddressRequired: null,
            beneficiarySSNRequired: false,
            beneficiaryDOBRequired: false,
            qjsaVerificationRequired: null,
            participantAddressOnFile: {},
            designations: [],
            beneficiaryTypes: [],
            maritalStatuses: [],
            states: [],
            countries: [],
            beneficiaries: {
                Primary: [],
                Contingent: []
            }
        };
    }

    function processBeneficiaryResponse(data) {
        serviceData.designations = normalizeRecords(data.designations);
        serviceData.beneficiaryTypes = normalizeRecords(data.beneficiaryTypes);
        serviceData.maritalStatuses = normalizeRecords(data.maritalStatuses);
        serviceData.states = normalizeRecords(data.states);
        serviceData.countries = normalizeRecords(data.countries);

        // Default showMaritalStatus to TRUE
        if (data.hasOwnProperty("showMaritalStatus")) {
            serviceData.showMaritalStatus = data.showMaritalStatus === true;
        } else {
            serviceData.showMaritalStatus = true;
        }

        serviceData.beneficiaryAddressRequired = data.beneficiaryAddressRequired;
        if (data.hasOwnProperty("beneficiarySSNRequired") && data.beneficiarySSNRequired !== null) {
            serviceData.beneficiarySSNRequired = data.beneficiarySSNRequired;
        }

        if (data.hasOwnProperty("qjsaVerificationRequired")) {
            serviceData.qjsaVerificationRequired = data.qjsaVerificationRequired;
        }

        if (data.hasOwnProperty("beneficiaryDOBRequired") && data.beneficiaryDOBRequired !== null) {
            serviceData.beneficiaryDOBRequired = data.beneficiaryDOBRequired;
        }

        if (serviceData.beneficiaryAddressRequired) {
            // Set default address fields to prevent errors
            data.participantAddressOnFile.zipCode = getModifiedZipcode(
                data.participantAddressOnFile.country,
                data.participantAddressOnFile.zipCode
            );
            data.participantAddressOnFile = _.defaults(data.participantAddressOnFile, {
                firstLineMailing: "",
                scndLineMailing: "",
                city: "",
                stateCode: "",
                zipCode: "",
                country: ""
            });

            serviceData.participantAddressOnFile = {
                address1: data.participantAddressOnFile.firstLineMailing,
                address2: data.participantAddressOnFile.scndLineMailing,
                city: data.participantAddressOnFile.city,
                state: getCodeValue(serviceData.states, data.participantAddressOnFile.stateCode),
                zipCode: data.participantAddressOnFile.zipCode,
                country: getCodeValue(serviceData.countries, data.participantAddressOnFile.country)
            };
        } // if ( serviceData.beneficiaryAddressRequired )

        // Set marital status
        if (data.hasOwnProperty("maritalStatus")) {
            serviceData.maritalStatus = data.maritalStatus.code;
        } else {
            serviceData.maritalStatus = null;
        }

        if (data.hasOwnProperty("beneficiaries")) {
            angular.forEach(data.beneficiaries, function (beneficiary) {
                var bene = {
                    id: beneficiary.id,
                    useAddressOnFile: false, // TODO: Where does this come from?
                    beneficiaryDesignation: beneficiary.designationCode,
                    previousDesignation: beneficiary.designationCode,
                    beneficiaryType: beneficiary.beneTypeCode,
                    beneficiaryFirstName: beneficiary.firstName,
                    beneficiaryMiddleName: beneficiary.middleName,
                    beneficiaryLastName: beneficiary.lastName,
                    beneficiarySuffix: beneficiary.suffix,
                    allocationPercent: beneficiary.percent,
                    socialSecurityNumber: MaskUtil.convertFromBackendMask(
                        beneficiary.socialSecurityNumber,
                        ""
                    ),
                    dateOfBirth: MaskUtil.convertFromBackendMask(beneficiary.dateOfBirth, ""),
                    phoneNumber: beneficiary.phoneNumber,
                    saveErrors: null,
                    validity: getValidBeneRelationShip(
                        beneficiary.beneTypeCode,
                        serviceData.beneficiaryTypes
                    )
                };

                if (serviceData.beneficiaryAddressRequired) {
                    var addressFields = {
                        address1: "",
                        address2: "",
                        city: "",
                        state: "",
                        zipCode: "",
                        country: ""
                    };

                    _.assign(bene, addressFields);

                    if (
                        beneficiary.hasOwnProperty("beneficiaryAddress") &&
                        beneficiary.beneficiaryAddress !== null
                    ) {
                        bene.address1 = beneficiary.beneficiaryAddress.hasOwnProperty(
                            "firstLineMailing"
                        )
                            ? beneficiary.beneficiaryAddress.firstLineMailing
                            : "";
                        bene.address2 = beneficiary.beneficiaryAddress.hasOwnProperty(
                            "scndLineMailing"
                        )
                            ? beneficiary.beneficiaryAddress.scndLineMailing
                            : "";
                        bene.city = beneficiary.beneficiaryAddress.hasOwnProperty("city")
                            ? beneficiary.beneficiaryAddress.city
                            : "";
                        bene.state =
                            beneficiary.beneficiaryAddress.hasOwnProperty("stateCode") &&
                            serviceData.states &&
                            serviceData.states.length > 0
                                ? getCodeValue(
                                      serviceData.states,
                                      beneficiary.beneficiaryAddress.stateCode
                                  )
                                : "";
                        bene.zipCode = beneficiary.beneficiaryAddress.hasOwnProperty("zipCode")
                            ? getModifiedZipcode(
                                  beneficiary.beneficiaryAddress.country,
                                  beneficiary.beneficiaryAddress.zipCode
                              )
                            : "";
                        bene.country =
                            beneficiary.beneficiaryAddress.hasOwnProperty("country") &&
                            serviceData.countries &&
                            serviceData.countries.length > 0
                                ? getCodeValue(
                                      serviceData.countries,
                                      beneficiary.beneficiaryAddress.country
                                  )
                                : "";
                    }
                } // if ( serviceData.beneficiaryAddressRequired )

                if (beneficiary.designationCode == "P") {
                    // TODO: Get confirmation on designation values
                    serviceData.beneficiaries.Primary.push(bene);
                } else {
                    serviceData.beneficiaries.Contingent.push(bene);
                }
            });
        } // if ( data.hasOwnProperty('beneficiaries') )
    }

    return {
        beneficiaryResponse: function (gaId) {
            var deferred = $q.defer();
            var groupIdparam = "";

            if (gaId) {
                groupIdparam = gaId;
                existingGroupId = gaId;
            } else {
                groupIdparam = this.getGroupId();
                existingGroupId = this.getGroupId();
            }

            initServiceData();

            // Get the 'BeneficiaryResponse' object
            $http
                .get(
                    __baseApiUrl__ +
                        "/participant-web-services/rest/beneficiary/getBeneficiaries/" +
                        groupIdparam
                )
                .success(function (data, status, headers, config) {
                    initServiceData();
                    // Pass through to another function so it is testable
                    processBeneficiaryResponse(data);

                    deferred.resolve();
                })
                .error(function (data, status, headers, config) {
                    deferred.reject(headers("exceptionMessage"));
                });

            return deferred.promise;
        },
        setBeneficiaryResponse: function (data) {
            initServiceData();

            processBeneficiaryResponse(data);
        },
        getServiceData: function (property, groupId) {
            var deferred = $q.defer();

            if (
                typeof serviceData !== "undefined" &&
                serviceData.hasOwnProperty(property) &&
                existingGroupId &&
                existingGroupId == this.getGroupId()
            ) {
                deferred.resolve(serviceData[property]);
            } else {
                this.beneficiaryResponse(groupId).then(
                    function () {
                        deferred.resolve(serviceData[property]);
                    },
                    function (failureReason) {
                        deferred.reject(failureReason);
                    }
                );
            }

            return deferred.promise;
        },
        setServiceData: function (property, value) {
            if (typeof serviceData === "undefined") {
                initServiceData();
            }

            serviceData[property] = value;
        },
        reset: function () {
            serviceData = {};
        },
        getBeneficiaries: function (groupId) {
            return this.getServiceData("beneficiaries", groupId);
        },
        setBeneficiaries: function (beneficiaries) {
            this.setServiceData("beneficiaries", beneficiaries);
        },
        getShowMaritalStatus: function (groupId) {
            return this.getServiceData("showMaritalStatus", groupId);
        },
        getMaritalStatus: function (groupId) {
            return this.getServiceData("maritalStatus", groupId);
        },
        setMaritalStatus: function (maritalStatus) {
            this.setServiceData("maritalStatus", maritalStatus);
        },
        getBeneficiaryDesignations: function (groupId) {
            return this.getServiceData("designations", groupId);
        },
        setBeneficiaryDesignations: function (designations) {
            this.setServiceData("designations", designations);
        },
        getBeneficiaryTypes: function (groupId) {
            return this.getServiceData("beneficiaryTypes", groupId);
        },
        setBeneficiaryTypes: function (beneficiaryTypes) {
            this.setServiceData("beneficiaryTypes", beneficiaryTypes);
        },
        getMaritalStatuses: function (groupId) {
            return this.getServiceData("maritalStatuses", groupId);
        },
        setMaritalStatuses: function (maritalStatuses) {
            this.setServiceData("maritalStatuses", maritalStatuses);
        },
        getCountries: function (groupId) {
            return this.getServiceData("countries", groupId);
        },
        setCountries: function (countries) {
            this.setServiceData("countries", countries);
        },
        getStates: function (groupId) {
            return this.getServiceData("states", groupId);
        },
        setStates: function (states) {
            this.setServiceData("states", states);
        },
        getQjsaVerificationRequired: function (groupId) {
            return this.getServiceData("qjsaVerificationRequired", groupId);
        },
        setQjsaVerificationRequired: function (qjsaVerificationRequired) {
            this.setServiceData("qjsaVerificationRequired", qjsaVerificationRequired);
        },
        getBeneficiaryAddressRequired: function (groupId) {
            return this.getServiceData("beneficiaryAddressRequired", groupId);
        },
        setBeneficiaryAddressRequired: function (beneficiaryAddressRequired) {
            this.setServiceData("beneficiaryAddressRequired", beneficiaryAddressRequired);
        },
        getBeneficiarySSNRequired: function (groupId) {
            return this.getServiceData("beneficiarySSNRequired", groupId);
        },
        setBeneficiarySSNRequired: function (beneficiarySSNRequired) {
            this.setServiceData("beneficiarySSNRequired", beneficiarySSNRequired);
        },
        getBeneficiaryDOBRequired: function (groupId) {
            return this.getServiceData("beneficiaryDOBRequired", groupId);
        },
        setBeneficiaryDOBRequired: function (beneficiaryDOBRequired) {
            this.setServiceData("beneficiaryDOBRequired", beneficiaryDOBRequired);
        },
        getParticipantAddressOnFile: function (groupId) {
            return this.getServiceData("participantAddressOnFile", groupId);
        },
        setParticipantAddressOnFile: function (participantAddressOnFile) {
            this.setServiceData("participantAddressOnFile", participantAddressOnFile);
        },
        getHasParticipantAddressOnFile: function (groupId) {
            var deferred = $q.defer();

            this.getParticipantAddressOnFile(groupId).then(function (participantAddressOnFile) {
                var hasParticipantAddressOnFile = false;

                if (
                    participantAddressOnFile &&
                    participantAddressOnFile.address1 !== "" &&
                    participantAddressOnFile.address1 !== null &&
                    participantAddressOnFile.city !== "" &&
                    participantAddressOnFile.city !== null &&
                    participantAddressOnFile.state !== "" &&
                    participantAddressOnFile.state !== null &&
                    participantAddressOnFile.zipCode !== "" &&
                    participantAddressOnFile.zipCode !== null
                ) {
                    hasParticipantAddressOnFile = true;
                }

                deferred.resolve(hasParticipantAddressOnFile);
            });

            return deferred.promise;
        },
        save: function (maritalStatus, beneficiaries, groupId) {
            var deferred = $q.defer();

            if (!groupId) {
                groupId = this.getGroupId();
            }

            // Send back null value for marital status if it is not set in the UI
            if (!maritalStatus) {
                maritalStatus = null;
            }

            var data = {
                maritalStatus: maritalStatus,
                beneficiaries: []
            };

            angular.forEach(beneficiaries, function (beneficiary) {
                var bene = {};

                // Remove properties that are not allowed by the yellow box
                if (beneficiary.hasOwnProperty("remove")) {
                    delete beneficiary.remove;
                }

                if (beneficiary.hasOwnProperty("previousDesignation")) {
                    delete beneficiary.previousDesignation;
                }

                if (beneficiary.hasOwnProperty("saveErrors")) {
                    delete beneficiary.saveErrors;
                }

                if (beneficiary.hasOwnProperty("previousDOB")) {
                    delete beneficiary.previousDOB;
                }

                if (beneficiary.hasOwnProperty("previousSSN")) {
                    delete beneficiary.previousSSN;
                }

                if (beneficiary.newDOB === null) {
                    delete beneficiary.newDOB;
                }

                if (beneficiary.newSSN === null) {
                    delete beneficiary.newSSN;
                }

                delete beneficiary.useAddressOnFile;
                delete beneficiary.beneficiaryState;
                delete beneficiary.uniqueId;
                delete beneficiary.name;
                delete beneficiary.validity;

                // Add beneficiary values to the bene object
                _.forIn(beneficiary, function (value, key) {
                    bene[key] = value;
                });

                if (beneficiary.beneficiaryDesignation !== null) {
                    bene.beneficiaryDesignation = beneficiary.beneficiaryDesignation;
                }

                // Convert CodeDescription object values to their code only
                if (beneficiary.state && beneficiary.state.hasOwnProperty("code")) {
                    bene.state = beneficiary.state.code;
                }

                if (beneficiary.zipCode === "") {
                    bene.zipCode = null;
                }

                if (beneficiary.country && beneficiary.country.hasOwnProperty("code")) {
                    //international address the state fields in the db should be set to null
                    if (!(beneficiary.country.code == "US" || beneficiary.country.code == "CA")) {
                        bene.state = null;
                    }

                    bene.country = beneficiary.country.code;
                }

                // Clean the beneficiary if it is not an individual
                if (beneficiaryService.getType(bene) !== beneficiaryTypeCodes.Individual) {
                    bene.beneficiaryFirstName = null;
                    bene.beneficiaryMiddleName = null;
                    bene.beneficiarySuffix = null;
                }

                // Convert masked values
                if (bene.socialSecurityNumber) {
                    bene.socialSecurityNumber = MaskUtil.convertToBackendMask(
                        bene.socialSecurityNumber
                    );
                }
                if (bene.dateOfBirth) {
                    bene.dateOfBirth = MaskUtil.convertToBackendMask(bene.dateOfBirth);
                }

                data.beneficiaries.push(bene);
            });
            $http
                .post(
                    __baseApiUrl__ +
                        "/participant-web-services/rest/beneficiary/saveBeneficiaries/" +
                        groupId,
                    data
                )
                .success(function (data, status, headers, config) {
                    // Get confirmation number and pass back through resolve()
                    deferred.resolve(data);
                })
                .error(function (data, status, headers, config, statusText) {
                    deferred.reject(headers("exceptionMessage"));
                });

            return deferred.promise;
        },
        getAddress: function (beneficiaries) {
            var deferred = $q.defer();
            $http
                .get(
                    __baseApiUrl__ +
                        "/participant-web-services/rest/participant/getAddress/" +
                        beneficiaries.country.code +
                        "/" +
                        beneficiaries.state.code +
                        "/" +
                        beneficiaries.zipCode
                )
                .success(function (data, status, headers, config) {
                    // Pass through to another function so it is testable

                    deferred.resolve({
                        validZipcode: data
                    });
                })
                .error(function (data, status, headers, config) {
                    deferred.reject(headers("exceptionMessage"));
                });

            return deferred.promise;
        },
        getGroupId: function () {
            if (groupId) {
                return groupId;
            } else {
                return $stateParams.groupId;
            }
        },
        setGroupId: function (value) {
            groupId = value;
        }
    };
};

var getModifiedZipcode = function (country, zipCode) {
    if (zipCode === null) {
        return zipCode;
    }
    if (country == "US") {
        zipCode = zipCode.substr(0, 5);
        return zipCode;
    } else {
        return zipCode;
    }
};

var getValidBeneRelationShip = function (TypeCode, beneficiaryTypes) {
    var arr = [];
    angular.forEach(beneficiaryTypes, function (record) {
        arr.push(record.code);
    });
    var foundValidRelationShip = false;
    angular.forEach(arr, function (value) {
        if (value == TypeCode) {
            foundValidRelationShip = true;
        }
    });
    return foundValidRelationShip;
};

var getCodeValue = function (source, code) {
    if (typeof source === "undefined" || typeof code === "undefined") {
        return null;
    }

    var index = _.findIndex(source, { code: code });

    return index >= 0 ? source[index] : null;
};

DataService.$inject = ["$http", "$injector", "$q", "beneficiaryService"];
export default DataService;
